import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { OpenEndElement_element$data } from "../../__generated__/OpenEndElement_element.graphql";
import { OpenEndElement_screener$data } from "../../__generated__/OpenEndElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: OpenEndElement_element$data;
  screener: OpenEndElement_screener$data;
} & CommonElementProps;
const OpenEndElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(OpenEndElement, {
  element: graphql`
    fragment OpenEndElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment OpenEndElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
